import { http, uploadFile } from '@/utils/axios'
import qs from 'qs'


/**
 * @msg: 获取证书列表
 */
export function elExamsCertList({page = 0, pageSize = 10,certName="",certId=""}) {
    return http({
        url:http.baseUrl('elExamsCert/elExamsCertList'),
        method:'get',
        params:http.params({
            page,
            pageSize,
            certId,
            certName,
        })
    })
}

/**
 * @msg: 获取用户证书列表
 */
 export function elExamsUserCertList({page = 0, pageSize = 10, certCode="", uName=""}) {
    return http({
        url:http.baseUrl('elExamsCert/elExamsUserCertList'),
        method:'get',
        params:http.params({
            page,
            pageSize,
            uName,
            certCode,
        })
    })
}

/**
 * @msg:新增
 */
 export function saveOrUpdate (params) {
    console.log(JSON.stringify(params));
   return http({
     url: http.baseUrl('elExamsCert/saveOrUpdate'),
     method: 'post',
     params: http.params(params)
   })
 }

/**
 * @msg:删除
 */
 export function deletes (data) {
    console.log("data.", data);
   return http({
     url: http.baseUrl('elExamsCert/delete'),
     method: 'post',
     params: http.params(data)
   })
  }

  /**
 * @msg:检查试卷或者点播课是否存在
 */
 export function checkExams (data) {
    console.log("data.", data);
   return http({
     url: http.baseUrl('elExamsCert/checkExams'),
     method: 'post',
     params: http.params(data)
   })
  }

  /**
 * @msg:获取查看证书的内容
 */
export function getCertContent(data) {
  return http({
      url:http.baseUrl('elExamsCert/getCertContent'),
      method:'get',
      params:http.params(data)
  })
}